<template>
    <div class="income">
        <div class="income-title">{{ $t('copartner_update_1') }}</div>
        <div class="income-wrap">
            <div class="title">
                <div v-for="(item, index) in title" :key="index">{{ $t(item) }}</div>
            </div>
            <div :class="['content', { last: index === content.length - 1 }]" v-for="(item, index) in content" :key="index">
                <div v-for="(itd, idx) in item" :key="idx">
                    <template v-if="itd.type === 'title'">{{ $t(itd.value) }}</template>
                    <template v-if="itd.type === 'rate'">{{ partnerInfo.configs[itd.key].rebateRate * 100 + '%' }}</template>
                    <div class="check" v-if="itd.type === 'check'"></div>
                </div>
            </div>
        </div>
        <div class="rule" v-html="$t('copartner_more_detail')"></div>
    </div>
</template>
<script setup lang="tsx">
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'
const store = useBaseStore()
const { partnerInfo } = storeToRefs(store)
const title = ['copartner_level', 'copartner_level_1', 'copartner_level_2', 'copartner_level_3', 'copartner_level_4', 'copartner_level_5']
const content = [
    [
        {
            type: 'title',
            value: 'copartner_commissio_rate',
        },
        {
            type: 'rate',
            key: 0,
        },
        {
            type: 'rate',
            key: 1,
        },
        {
            type: 'rate',
            key: 2,
        },
        {
            type: 'rate',
            key: 3,
        },
        {
            type: 'rate',
            key: 4,
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_fee',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_avatar',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_training_support',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_cocreation',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_build_team',
        },
        {
            type: 'empty',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_dividend',
        },
        {
            type: 'empty',
        },
        {
            type: 'empty',
        },
        {
            type: 'empty',
        },
        {
            type: 'check',
        },
        {
            type: 'check',
        },
    ],
    [
        {
            type: 'title',
            value: 'copartner_star',
        },
        {
            type: 'empty',
        },
        {
            type: 'empty',
        },
        {
            type: 'empty',
        },
        {
            type: 'empty',
        },
        {
            type: 'check',
        },
    ],
]
</script>
<style lang="scss" scoped>
.income {
    margin: 39px 0 34px;
    .income-title {
        margin-bottom: 13px;
        font-size: 30px;
    }
    .income-wrap {
        padding: 3px;
        // height: 140px;
        background-image: linear-gradient(rgba(191, 100, 229, 0.15), rgba(191, 100, 229, 0.15)), linear-gradient(#332c44, #332c44);
        background-blend-mode: normal, normal;
        border-radius: 30px;
        border: solid 3px #553669;

        .title,
        .content {
            @apply flex gap-[2px];
            font-size: 20px;

            // border-radius: 30px 30px 0 0;
            overflow: hidden;

            div {
                &:first-child {
                    flex: 0 0 150px;
                    padding: 0 20px;
                }
                @apply flex items-center justify-center flex-1;
                background: rgba(249, 80, 136, 0.15);
                height: 54px;
                // border-right: 2px solid linear-gradient(rgba(191, 100, 229, 0.15), rgba(191, 100, 229, 0.15)),
                //     linear-gradient(#332c44, #332c44);
            }
        }
        .content {
            // @apply flex gap-[2px];
            margin-bottom: 2px;

            div {
                flex: 0 0 1;
                height: 72px;
                background: #40274e;
                color: #ffc22b;
                word-break: break-all;

                &:first-child {
                    color: #b88dcb;
                    text-align: center;
                }
            }
            .check {
                background: url('@/assets/img/bloom/check.png') no-repeat center center;
                background-size: 48px 32px;
            }
        }
        .last {
            &:first-child,
            &:last-child {
                border-radius: 0 0 30px 30px;
            }
        }
    }
    .rule {
        margin-top: 30px;
        line-height: 40px;
        font-size: 22px;
        color: #b88ecb;
        :deep(span) {
            color: #fff;
        }
    }
}
</style>
